var React = require('react');

function Cloud2 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M30.2005 119.48H242.501C242.501 119.48 264.721 117.65 265.101 96.8796C265.481 76.1096 243.901 64.4596 224.701 74.3896C224.701 74.3896 229.661 56.2696 214.991 43.3196C200.321 30.3796 182.631 42.2396 182.631 42.2396C182.631 42.2396 194.711 20.0196 169.041 4.69959C143.371 -10.6204 127.401 15.6996 128.261 27.9996C128.261 27.9996 103.231 -19.2504 50.5905 9.00959C50.5905 9.00959 19.5205 25.1896 35.2705 63.8096C35.2705 63.8096 7.06053 58.4696 0.750535 88.0796C-5.55946 117.69 30.2005 119.48 30.2005 119.48Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"265.1","height":"119.48","fill":"white"})))]);
}

Cloud2.defaultProps = {"width":"266","height":"120","viewBox":"0 0 266 120","fill":"none"};

module.exports = Cloud2;

Cloud2.default = Cloud2;
